import {Component, Input} from '@angular/core';
import {PlanCategory} from '@ox/typings';

@Component({
  selector: 'webu-plan-category',
  templateUrl: './plan-category.component.html'
})
export class PlanCategoryComponent {

  @Input() category: PlanCategory;
  @Input() orderIdMap: {[key: string]: string} = {};

 }
